<template>
    <v-dialog-old ref="dialog"  id="reviewAnswerDialog">
        <ValidationObserver ref="reviewComments">
            <fieldset>
                <legend v-if="directQuestion.interviewee">Отзыв о {{directQuestion.interviewee.name}}</legend>
                <div style="float: right"><i>{{directQuestion.created_at | formatDate}}</i></div>
                <div><b>{{directQuestion.author_name}}</b></div>

                <br />
                <div class="commentText" style="padding-bottom: 10px">
                        {{directQuestion.text}}
                </div>

                <div v-for="row in directQuestion.answers" style="padding-left: 50px; padding-bottom: 10px" class="commentText">
                    <div style="float: right"><i>{{row.created_at | formatDate}}</i><br></div>
                    <div>
                        <b v-if="row.author_type === 'CLINIC'">Ответ клиники:</b>
                        <b v-if="row.author_type === 'NETWORK'">Ответ сети:</b>
                        <b v-if="row.author_type === 'DOCTOR'">Ответ врача: </b>
                        <b v-if="row.author_type === 'PATIENT'">Ответ пациента: </b>
                        <button v-if="row.editable" class="tiny" @click="beginEditReply(row)" :disabled="row.editable && row.id === M.id">Изменить</button>
                    </div>
                    <div>{{row.text}}</div>
                </div>

                <div>
                    <label v-if="M.id === ''">Новый ответ</label>
                    <label v-else>Изменить ответ от {{M.created_at | formatDate}}</label>

                    <vee-textarea rows="3" rules="required" v-model="M.text"/>

                    <v-loading-component @click="newReply" v-if="M.id === ''">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['small green', loadingClass]">Добавить ответ</button>
                        </template>
                    </v-loading-component>

                    <v-loading-component @click="updateReply" v-if="M.id !== ''">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['small green', loadingClass]">Сохранить ответ</button>
                        </template>
                    </v-loading-component>

                    <v-loading-component @click="deleteReply" v-if="M.id !== ''">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['small red', loadingClass]">Удалить ответ</button>
                        </template>
                    </v-loading-component>
                    <button class="small" @click="clearM()" v-if="M.id !== ''">Отменить изменение</button>
                </div>
            </fieldset>
        </ValidationObserver>
    </v-dialog-old>
</template>

<script>
import Vue from "vue";
export default {
    data: function () {
        return {
            directQuestion: {},
            M: {
                id:         '',
                created_at:  '',
                text:    '',
            }
        };
    },
    methods: {
        show (directQuestion) {
           this.directQuestion = directQuestion;
           return  this.$refs.dialog.show();
        },
        newReply (btn) {
                btn.startLoadingAnimation()
                this.$refs.reviewComments.validate().then(success => {
                    if (!success) {
                        const el = document.querySelector(".hasError:first-of-type");
                        el.scrollIntoView({behavior: "smooth"});
                        btn.stopLoadingAnimation()
                        return;
                    }
                    this.axios.post('directQuestions/'+this.directQuestion.id+'/createComment', {text: this.M.text}).then( (response) => {
                        this.hide();


                        btn.stopLoadingAnimation();
                    }, () => btn.stopLoadingAnimation());
                });
        },
        beginEditReply (row) {
            this.M.id = row.id;
            this.M.created_at = row.created_at;
            this.M.text = row.text;
        },
        hide (){
            this.$refs.dialog.hide()
            this.clearM();
            this.$parent.$refs.table.update();
        },
        updateReply (btn) {
            btn.startLoadingAnimation()
            this.$refs.reviewComments.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    btn.stopLoadingAnimation()
                    return;
                }
                this.axios.post('directQuestions/'+this.directQuestion.id+'/updateComment/'+this.M.id, {text: this.M.text}).then( () => {
                    this.hide();
                    btn.stopLoadingAnimation();
                }, () => btn.stopLoadingAnimation());
            });

        },
        deleteReply (btn) {
            btn.startLoadingAnimation()
                this.axios.post('directQuestions/'+this.directQuestion.id+'/deleteComment/'+this.M.id).then( () => {
                    this.hide();
                    btn.stopLoadingAnimation();
                }, () => btn.stopLoadingAnimation());

        },
        clearM () {
            this.M.id = '';
            this.M.text = '';
            this.M.created_at = '';
        }
    }
}
</script>
<style>
#reviewAnswerDialog {
    max-width: 1000px;
}
</style>
